import React, { Component, Fragment } from 'react';
import styles from './styles';
import { Error } from '../../../library';
import { css } from 'aphrodite';
import PackagingButton from './PackagingButton/PackagingButton';
import { ReactComponent as Arrow } from '../../../assets/images/arrow.svg';
import { ReactComponent as Eye } from '../../../assets/images/eye.svg';

var prevPackage = '';
class Product extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openedPackage: null,
            selectedPackage: null,
            isError: props.isError,
            isProductsListOpened: false,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.isError !== this.props.isError) {
            this.setState({isError: this.props.isError});
        }
        // Reset Selected package if Selected Product is changed
        if(prevProps.selectedProduct !== this.props.selectedProduct) {
            this.setState({selectedPackage: null});
        }
    }

    selectPackage(packageSealant) {
        const { dataLayer } = this.props;

        this.setState({ selectedPackage: packageSealant }, ()=>{
            this.props.onQuantitySelected(this.state.selectedPackage);
            if (prevPackage !== this.state.selectedPackage) {
                // Update datalayer when infos are available
                // if (dataLayer !== null) {
                //     dataLayer.push({
                //         'event': 'typeOfJointSealantSelection',
                //         'typeOfGrout': product.title,
                //     });

                //     console.log(dataLayer);
                // }

                prevPackage = packageSealant;
            }
        });
    }

    render() {
        const {
            data,
            linkTitle,
            dataLayer,
            selectedProduct,
            context,
            isResult,
            finalProductQuantity,
            backerRodPackage,
            jobType,
            isImperialSystem,
            cartridgeType,
            cartridgeLabel,
            chooseLabel,
            backerRodPackagelabel,
            noBackerRodPackageLabel,
            titleCertificate,
            titleRelatedCleaners,
            packaging,
            isQuantityError,
            errorPackagingLabel,
            openProductsList,
        } = this.props;

        var isInt = context === 'int';
        var isQual = context === 'qual';
        var isProd = context === 'prod';
        var islocal = context === 'local';

        let packagingArray = {};
        let packagingArraySorted;

        // Get all packages, create an object with each packaging type as a key, with entities as values
        // Sort types by name, and entities by quantity
        if(!isResult && selectedProduct && (selectedProduct.nid === data.nid)) {
            data.fieldPackagingSealant.map((packaging) => {
                if(packagingArray[packaging.entity.fieldPackagingType.entity.entityLabel] === undefined) {
                    return packagingArray[packaging.entity.fieldPackagingType.entity.entityLabel] = [packaging];
                } else {
                    return packagingArray[packaging.entity.fieldPackagingType.entity.entityLabel].push(packaging);
                }
            });
            packagingArraySorted = Object.keys(packagingArray).sort()
            .reduce((accumulator, key) => {
              accumulator[key] = packagingArray[key];

              return accumulator;
            }, {});
            Object.keys(packagingArray).map((packaging) => {
                return packagingArray[packaging].sort(
                    (a, b) => {
                        return a.entity.fieldQuantity - b.entity.fieldQuantity;
                    }
                );
            });
        }

        // Use of Fragment to show error on the outside of the product
        return (
            <Fragment>
                <div className={css(styles.productWrapper, isResult && styles.productWrapperResult, isQuantityError && styles.containerError)}>
                    <div className={css(styles.product, isResult && styles.productResult)}>
                        {data.fieldImage &&
                            <figure className={css(styles.figure, isResult && styles.figureResult)}>
                                <img className={css(styles.image)} src={data.fieldImage.entity.fieldMediaImage.entity.url} alt=""/>
                            </figure>
                        }
                        <div className={css(!isResult && styles.textWrapper, isResult && styles.textWrapperResult)}>
                            <div className={css(styles.productTitleWrapper, isResult && styles.productTitleWrapperResult)}>
                                {isResult &&
                                <p className={css(styles.productQuantity)}>
                                    <span className={css(styles.productQuantitySpan)}>{finalProductQuantity}&nbsp;</span>
                                    <span className={css(styles.productQuantityMaj)}>
                                        { cartridgeType.toLowerCase() }
                                    </span>
                                    &nbsp;{ cartridgeLabel }
                                    <span className={css(styles.productQuantitySpan)}> {packaging}{isImperialSystem ? 'oz' : 'ml'}</span>
                                </p>
                                }

                                <h2 className={css(styles.title)}>{data.title}</h2>


                                {isResult && linkTitle ?
                                    <a className={css(
                                        styles.link,
                                        !data.body && styles.noDescription,
                                        isInt && styles.iconLinkInt,
                                        isQual && styles.iconLinkQual,
                                        isProd && styles.iconLinkProd,
                                        islocal && styles.iconLinklocal,
                                        isResult && styles.ButtonPrimary
                                    )}
                                    href={data.fieldLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => {
                                            if (dataLayer !== null) {
                                                dataLayer.push({
                                                    'event' : 'eventGA',
                                                    'eventCategory': 'calculator',
                                                    'eventAction': 'product click',
                                                    'eventLabel': data.title
                                                });
                                                console.log(dataLayer);

                                            }
                                        }}
                                        >
                                        {linkTitle}

                                        <span className={css(styles.buttonArrow)}>
                                            <Arrow className={css(styles.buttonArrowSvg)} />
                                        </span>

                                    </a>
                                    :
                                    ''
                                }
                            </div>

                            <div className={css(!isResult && styles.descriptionWrapper, isResult && styles.descriptionWrapperResult)}>
                                {data.body && !isResult ?
                                <div className={css(styles.description)}
                                    dangerouslySetInnerHTML={{__html: data.body.value}}></div>
                                : ''
                                }

                                { data.fieldCertificate &&
                                <div className={css(styles.certificate)}>
                                    {titleCertificate &&
                                    <div className={css(styles.productDescriptionListTitle)} dangerouslySetInnerHTML={{__html: titleCertificate}}></div>
                                    }
                                    <div  dangerouslySetInnerHTML={{__html: data.fieldCertificate.value}}></div>

                                    {isResult && jobType === 'square' ?
                                    <div>
                                        {data.fieldTitleBackerRod &&
                                        <div className={css(styles.productDescriptionListTitle)} dangerouslySetInnerHTML={{__html: data.fieldTitleBackerRod}}></div>
                                        }
                                        <span className={css(styles.backerRod)}>
                                            {backerRodPackage ?
                                            `${backerRodPackagelabel} ${backerRodPackage}${isImperialSystem ? '"' : ' mm'}`
                                            :
                                            noBackerRodPackageLabel
                                            }
                                        </span>
                                    </div>
                                    :
                                    ''
                                    }

                                    {isResult && data.fieldRelatedProducts.length > 0 ?
                                    <div className={css(styles.relatedProducts)}>
                                        {titleRelatedCleaners &&
                                        <div className={css(styles.productDescriptionListTitle)} dangerouslySetInnerHTML={{__html: titleRelatedCleaners}}></div>
                                        }
                                        <ul>
                                        {data.fieldRelatedProducts.map((relatedProduct, index) => {
                                        return(
                                            <li key={index}>
                                                <a href={relatedProduct.uri} className={css(styles.relatedProductLink)}>
                                                    {relatedProduct.title}
                                                </a>
                                            </li>
                                            );
                                        })}
                                        </ul>
                                    </div>
                                    :
                                    ''
                                    }
                                </div>
                                }

                            </div>

                            {!isResult && linkTitle ?
                            <div className={css(styles.productLinkWrapper)}>
                                <a className={css(
                                    styles.link,
                                    styles.linkProduct,
                                    !data.body && styles.noDescription,
                                    isInt && styles.iconLinkInt,
                                    isQual && styles.iconLinkQual,
                                    isProd && styles.iconLinkProd,
                                    islocal && styles.iconLinklocal,
                                    isResult && styles.ButtonPrimary
                                )}
                                href={data.fieldLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => {
                                        if (dataLayer !== null) {
                                            dataLayer.push({
                                                'event' : 'eventGA',
                                                'eventCategory': 'calculator',
                                                'eventAction': 'product click',
                                                'eventLabel': data.title
                                            });
                                            console.log(dataLayer);

                                        }
                                    }}
                                    >
                                    <Eye className={css(styles.eye)} />
                                    {linkTitle}

                                </a>
                            </div>
                            :
                            ''
                            }
                        </div>
                    </div>
                    {!isResult && packagingArraySorted && Object.keys(packagingArraySorted).length > 0 &&
                        <div className={css(styles.productContainer, styles.packagesContainer)}>
                            <div className={css(styles.subtitle)}>{chooseLabel}&nbsp;:</div>
                            { Object.keys(packagingArraySorted).map((packaging) => {
                                return(
                                    <div key={packaging} className={css(styles.packagesFlexWrapper)}>
                                        <div className={css(styles.subsubtitle)}>{packaging}</div>
                                        { packagingArraySorted[packaging].map((d) => {
                                            return(
                                                <PackagingButton
                                                    key={d.entity.tid}
                                                    isSelected={this.state.selectedPackage && this.state.selectedPackage.tid === d.entity.tid}
                                                    onSelectPackage={() => this.selectPackage(d.entity)}
                                                    selectedPackage={this.state.selectedPackage}
                                                    packagingLabel={d.entity.name}
                                                    data={d.entity}
                                                    openProductsList={(e) => openProductsList(e)}
                                                />
                                            )
                                        }) }
                                    </div>
                                )
                            })}
                        </div>
                    }
                </div>
                {isQuantityError &&
                    <div className={css(styles.error)}>
                        <Error label={errorPackagingLabel} />
                    </div>
                }
            </Fragment>
        );
    }
}

Product.defaultProps = {
    lightVersion: false
}

export default Product;
